import { Stack, Typography, Skeleton, Divider, IconButton, Box, Link } from "@mui/material";
import { useState } from "react";
import Iconify from "../../minimals/components/iconify";
import OpenInHomePageButton from "../searches/OpenInHomePageButton";
import OpenInSelectButton from "../searches/OpenInSelectButton";
import GooglePin from "../shared/orderInfo/GooglePin";
import { OrderInfo } from "../shared/orderInfo/types";

interface Props {
   orderInfo: OrderInfo | null
   // Phones: push the Select / home page / map buttons to the right edge
   alignActionsRight?: boolean
}

const Properties = (props:Props) => {
  const [propertyIndex, setPropertyIndex] = useState<number>(0);

  const nextProperty = () => {
    setPropertyIndex((prev) => prev + 1);
  };

  const previousProperty = () => {
    setPropertyIndex((prev) => prev - 1);
  };

  const captionSx = { fontSize: { xs: "0.7rem", lg: "0.75rem" } };
  const subtitle1Sx = { fontSize: { xs: "0.85rem", lg: "1rem" } };

  return (
    <Box maxWidth={500} className="customCard" sx={{ alignItems: "flex-end", display: "flex" }}>
      <Stack direction="row" spacing={3}>
        <Box>
          <Typography variant="subtitle1" sx={subtitle1Sx}>
            {props.orderInfo?.properties[propertyIndex].address1}
            {!props.orderInfo && <Skeleton />}
          </Typography>
          <Typography variant="subtitle1" sx={subtitle1Sx}>
            {props.orderInfo?.properties[propertyIndex].city}
            {props.orderInfo?.properties[propertyIndex].city && ","} {props.orderInfo?.properties[propertyIndex].state}{" "}
            {props.orderInfo?.properties[propertyIndex].zip}
            {!props.orderInfo && <Skeleton />}
          </Typography>
          <Stack direction="row" spacing={3} justifyContent="space-between">
            {props.orderInfo?.properties[propertyIndex].state !== "NJ" &&
              props.orderInfo?.properties[propertyIndex].state !== "NY" && (
                <Box>
                  <Typography variant="caption" sx={captionSx}>
                    Parcel Id
                  </Typography>
                  <Typography variant="subtitle1" sx={subtitle1Sx}>
                    {props.orderInfo?.properties[propertyIndex].parcelIds.join(", ")}
                    {!props.orderInfo && <Skeleton />}
                  </Typography>
                </Box>
              )}
            {(props.orderInfo?.properties[propertyIndex].state === "NJ" ||
              props.orderInfo?.properties[propertyIndex].state === "NY") && (
              <Box>
                <Typography variant="caption" sx={captionSx}>
                  Section
                </Typography>
                <Typography variant="subtitle1" sx={subtitle1Sx}>
                  {props.orderInfo?.properties[propertyIndex].section}
                  {!props.orderInfo && <Skeleton />}
                </Typography>
              </Box>
            )}
            {(props.orderInfo?.properties[propertyIndex].state === "NJ" ||
              props.orderInfo?.properties[propertyIndex].state === "NY") && (
              <Box>
                <Typography variant="caption" sx={captionSx}>
                  Block
                </Typography>
                <Typography variant="subtitle1" sx={subtitle1Sx}>
                  {props.orderInfo?.properties[propertyIndex].block}
                  {!props.orderInfo && <Skeleton />}
                </Typography>
              </Box>
            )}
            {(props.orderInfo?.properties[propertyIndex].state === "NJ" ||
              props.orderInfo?.properties[propertyIndex].state === "NY") && (
              <Box>
                <Typography variant="caption" sx={captionSx}>
                  Lot
                </Typography>
                <Typography variant="subtitle1" sx={subtitle1Sx}>
                  {" "}
                  {props.orderInfo?.properties[propertyIndex].lots.join(", ")}
                  {!props.orderInfo && <Skeleton />}
                </Typography>
              </Box>
            )}
            <Box>
              <Typography variant="caption" sx={captionSx}>
                County
              </Typography>
              <Typography variant="subtitle1" sx={subtitle1Sx}>
                {props.orderInfo?.properties[propertyIndex].county}
                {!props.orderInfo && <Skeleton />}
              </Typography>
            </Box>
          </Stack>
          <Divider sx={{ marginTop: 2, marginBottom: 0.5 }} />
          <Box sx={{ left: -8, position: "relative" }}>
            <Stack direction="row" spacing={1} alignItems="center">
              <IconButton size="small" onClick={previousProperty} disabled={propertyIndex === 0}>
                <Iconify icon="eva:arrow-ios-back-outline" />
              </IconButton>
              <Typography variant="subtitle2">
                Property {propertyIndex + 1} of {props.orderInfo?.properties.length}
              </Typography>
              <IconButton
                size="small"
                onClick={nextProperty}
                disabled={props.orderInfo?.properties && propertyIndex === props.orderInfo?.properties?.length - 1}
              >
                <Iconify icon="eva:arrow-ios-forward-fill" />
              </IconButton>
              {/* "&&" outranks the parent Stack's spacing margin */}
              <Stack direction="row" spacing={1} alignItems="center" sx={props.alignActionsRight ? { "&&": { ml: "auto" } } : undefined}>
                <Box sx={{ position: "relative", top: 4 }}>
                  <OpenInSelectButton identifier={props.orderInfo?.identifier || ""} />
                </Box>
                <OpenInHomePageButton orderNumber={props.orderInfo?.number || ""} />
                <Link
                  href={`https://maps.google.com/?q=${props.orderInfo?.properties[propertyIndex].address1},${props.orderInfo?.properties[propertyIndex].city},${props.orderInfo?.properties[propertyIndex].state}`}
                  target="_blank"
                >
                  <IconButton>
                    <GooglePin />
                  </IconButton>
                </Link>
              </Stack>
            </Stack>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default Properties;
